const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmail = (text) => typeof text === 'string' && EMAIL_PATTERN.test(text.trim());

// Title is the name (or the email for a legacy email-only reviewer). The second line is the
// description (role) when given, otherwise the email — never repeating the title.
export const resolveUserLines = ({ name, email, description }) => {
    const title = (name || '').trim();
    const mail = (email || '').trim();
    const role = (description || '').trim();
    if (!title) return { title: mail, subtitle: role };
    if (role) return { title, subtitle: role };
    if (mail && mail.toLowerCase() === title.toLowerCase()) return { title, subtitle: '' };
    return { title, subtitle: mail };
};

// "Name <email>" (the collaborators source format) → { name, email }; anything else is the name.
export const parseUserText = (text) => {
    const raw = (text || '').trim();
    const match = raw.match(/^(.*?)\s*<([^<>]+)>\s*$/);
    if (!match) return isEmail(raw) ? { name: '', email: raw } : { name: raw, email: '' };
    return { name: match[1].trim(), email: match[2].trim() };
};
